import { REQUEST_FEATURES, RECEIVE_FEATURES } from '../constants/actionTypes';

export type FeatureFlagResponse = {
  value: unknown;
  'source-key'?: string;
} | string;

export type RequestFeaturesAction = {
  type: typeof REQUEST_FEATURES;
  flagNames: string[];
};

export type ReceiveFeaturesAction = {
  type: typeof RECEIVE_FEATURES;
  keys: string[];
  values: FeatureFlagResponse[];
  legacy?: true;
};

export function reqFeatures(flagNames: string[]): RequestFeaturesAction {
  return {
    type: REQUEST_FEATURES,
    flagNames,
  };
}

export function receiveLegacyFeatures(
  featureKeys: string[],
  values: FeatureFlagResponse[]
): ReceiveFeaturesAction {
  return {
    type: RECEIVE_FEATURES,
    keys: featureKeys,
    values,
    legacy: true,
  };
}

export function receiveFeatures(
  featureKeys: string[],
  values: FeatureFlagResponse[]
): ReceiveFeaturesAction {
  return {
    type: RECEIVE_FEATURES,
    keys: featureKeys,
    values,
  };
}
